import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import DailyLessonPlanForm from "./DailyLessonPlanForm";

const DailyLessonPlan = () => {
  const { planId } = useParams();

  return (
    <div className="flex-1 md:p-8 p-4 lg:mt-5 bg-gray-50 dark:bg-dark-500 lg:rounded-tl-3xl overflow-y-auto h-full custom-scrollbar">
      {/* Main Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="max-w-7xl mx-auto py-4 sm:px-6 lg:px-8"
      >
        <div className="px-4 py-4 sm:px-0">
          <DailyLessonPlanForm planId={planId ? parseInt(planId) : undefined} />
        </div>
      </motion.div>
    </div>
  );
};

export default DailyLessonPlan;
